import { BookOpen, Flame, Moon, HeartHandshake, Sparkles, ScrollText, Gift } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "@/components/mystic/Reveal";
import { BookMockup } from "@/components/mystic/BookMockup";
import { GoldButton } from "@/components/mystic/GoldButton";
import { useSettings } from "@/lib/settings";

const CONTENTS = [
  { icon: BookOpen, text: "50 simpatias com instruções passo a passo" },
  { icon: Flame, text: "Rituais com rosas, fitas, velas e objetos simbólicos" },
  { icon: Moon, text: "Orações e reflexões espirituais" },
  { icon: ScrollText, text: "Práticas para superar mágoas e afastamentos" },
  { icon: Sparkles, text: "Exercícios de amor-próprio e autoestima" },
  { icon: HeartHandshake, text: "Conselhos para uma reconciliação respeitosa" },
  { icon: Gift, text: "Bônus especiais sobre novos caminhos do amor" },
];

export function Produto() {
  const { settings } = useSettings();
  return (
    <section data-testid="produto-section" className="relative overflow-hidden bg-creme text-vinho">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-dourado to-transparent"
        aria-hidden="true"
      />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-12 lg:px-14">
        <div className="order-2 lg:order-1 lg:col-span-6">
          <Reveal>
            <Eyebrow light>Apresentação do produto</Eyebrow>
            <h2 className="font-serif text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl">
              UM LIVRO. 50 SIMPATIAS.
              <br />
              <span className="italic text-borgonha">UMA JORNADA DE RENOVAÇÃO.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <ul className="mt-10 space-y-4" data-testid="produto-conteudos">
              {CONTENTS.map((item, i) => (
                <li key={i} className="flex items-start gap-4">
                  <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-dourado/50 bg-white/60">
                    <item.icon className="h-4 w-4 text-borgonha" strokeWidth={1.8} />
                  </span>
                  <span className="pt-1.5 text-base font-medium leading-snug text-vinho/90">
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
            <div className="mt-10">
              <GoldButton testId="produto-cta-button" priceSize="sm" align="left" tone="light">QUERO ACESSAR O E-BOOK</GoldButton>
            </div>
          </Reveal>
        </div>
        <div className="order-1 flex justify-center lg:order-2 lg:col-span-6">
          <Reveal delay={0.1}>
            <div className="relative">
              <div
                className="absolute -inset-10 rounded-full bg-dourado/25 blur-3xl"
                aria-hidden="true"
              />
              <div className="absolute -inset-4 rounded-2xl border border-dourado/40" aria-hidden="true" />
              <div className="absolute -inset-8 rounded-3xl border border-dourado/20" aria-hidden="true" />
              <motion.div
                whileHover={{ y: -14, scale: 1.05, rotate: -2 }}
                transition={{ type: "spring", stiffness: 220, damping: 16 }}
                className="cursor-pointer"
                data-testid="produto-book-hover"
              >
                <BookMockup coverUrl={settings.cover_url} width={310} testId="produto-book-mockup" />
              </motion.div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
